module.exports = __webpack_public_path__ + "../resources/img/normal_mem_suc.a6477493.png";